/* ============================================================
   Summit MX — free shipping progress bar
   Added 2026-07-30.

   Shows how far the customer is from the free shipping
   threshold, in the cart drawer and on the /cart page.
   Updates itself whenever the cart changes.

   To revert: delete this file and remove the "Summit CRO assets"
   section from the header group. Nothing else is touched.
   ============================================================ */

(function () {
  'use strict';

  /* ---- CONFIG ---------------------------------------------
     THRESHOLD is in CENTS. $100.00 = 10000.
     Keep this in sync with:
       Settings > Shipping and delivery > General profile >
       Domestic > the "free over $X" rate.
     --------------------------------------------------------- */
  var THRESHOLD = 10000;
  var COPY_REMAINING = 'away from free shipping';
  var COPY_UNLOCKED = 'Free shipping unlocked';

  var BAR = 'summit-fsb';
  var lastCart = null;
  var lastRefresh = 0;

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function buildBar(total) {
    var remaining = Math.max(THRESHOLD - total, 0);
    var pct = Math.min(Math.round((total / THRESHOLD) * 100), 100);
    var done = remaining === 0;

    var el = document.createElement('div');
    el.className = BAR + (done ? ' ' + BAR + '--done' : '');
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');

    var label = done
      ? '<span class="' + BAR + '__check" aria-hidden="true">&#10003;</span>' + COPY_UNLOCKED
      : '<strong>' + money(remaining) + '</strong> ' + COPY_REMAINING;

    el.innerHTML =
      '<p class="' + BAR + '__label">' + label + '</p>' +
      '<div class="' + BAR + '__track">' +
      '<div class="' + BAR + '__fill" style="width:' + pct + '%"></div>' +
      '</div>';

    return el;
  }

  /* Where the bar gets inserted. Both are optional — whichever
     exists on the current page gets one. */
  function mountPoints() {
    var pts = [];

    var drawerFooter = document.querySelector(
      'cart-drawer .drawer__footer, #CartDrawer .drawer__footer'
    );
    if (drawerFooter && drawerFooter.parentNode) {
      pts.push({ parent: drawerFooter.parentNode, ref: drawerFooter });
    }

    var cartFooter = document.querySelector('#main-cart-footer .cart__footer, .cart__footer');
    if (cartFooter) {
      var totals = cartFooter.querySelector('.totals');
      if (totals && totals.parentNode) {
        pts.push({ parent: totals.parentNode, ref: totals });
      } else if (cartFooter.firstElementChild) {
        pts.push({ parent: cartFooter, ref: cartFooter.firstElementChild });
      }
    }

    return pts;
  }

  function clearBars() {
    var existing = document.querySelectorAll('.' + BAR);
    for (var i = 0; i < existing.length; i++) {
      existing[i].parentNode.removeChild(existing[i]);
    }
  }

  function render(cart) {
    lastCart = cart;
    clearBars();
    if (!cart || !cart.item_count) return;

    var pts = mountPoints();
    for (var i = 0; i < pts.length; i++) {
      pts[i].parent.insertBefore(buildBar(cart.total_price), pts[i].ref);
    }
  }

  function refresh(force) {
    var now = Date.now();
    if (!force && now - lastRefresh < 700) return;
    lastRefresh = now;

    nativeFetch
      .call(window, '/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(render)
      .catch(function () {
        /* cart unavailable — leave the page alone */
      });
  }

  /* --- Trigger 1: Dawn's own cart pub/sub, when available --- */
  try {
    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined' &&
      PUB_SUB_EVENTS.cartUpdate
    ) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        refresh(true);
      });
    }
  } catch (e) {
    /* theme doesn't expose pubsub — the fetch hook below covers it */
  }

  /* --- Trigger 2: any request that mutates the cart --------- */
  var nativeFetch = window.fetch;
  window.fetch = function () {
    var arg = arguments[0];
    var url = typeof arg === 'string' ? arg : (arg && arg.url) || '';
    var result = nativeFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      result
        .then(function () {
          setTimeout(function () {
            refresh(true);
          }, 150);
        })
        .catch(function () {});
    }
    return result;
  };

  /* --- Trigger 3: re-insert when the theme re-renders the
         cart drawer or cart section (Dawn replaces innerHTML) - */
  var debounce;
  var observer = new MutationObserver(function () {
    clearTimeout(debounce);
    debounce = setTimeout(function () {
      if (document.querySelector('.' + BAR)) return;
      if (!mountPoints().length) return;
      if (lastCart && !lastCart.item_count) return;
      refresh(false);
    }, 180);
  });

  function start() {
    observer.observe(document.body, { childList: true, subtree: true });
    refresh(true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
